const ConfirmModal = ({ message, onConfirm, onCancel, button }) => {
  return (
   <div className="w-screen h-screen flex flex-col items-center justify-center fixed top-0 left-0 right-0 z-[200] bg-gray-900/50 backdrop-blur-sm transition-opacity">
    <div className="relative  flex flex-col justify-center bg-white shadow-lg  rounded-lg font-body text-gray-900 text-center px-4 py-4"
    style={{ height: "225px", width: "500px" }}>

      <div className="flex flex-col  ml 4">
      <h2 className="text-2xl font-bold mb-4">¿Estás seguro?</h2>
      <p className="text-base text-gray-600 mb-4">{message}</p>
      </div>
      <div className=" mt-4">
        <button onClick={onCancel} className="px-4 py-2 rounded-full bg-gray-300 text-gray-800 hover:bg-gray-400 border-2">
          Cancelar
        </button>
        <button onClick={onConfirm} className="px-4 py-2 rounded-full bg-clvblue text-white hover:bg-red-700 ml-2">
          {button}
        </button>
      </div>
    </div>
  </div>
); 
}
  

export default ConfirmModal;